export const SET_HRMS74E_INDEX_DISP = 'SET_HRMS74E_INDEX_DISP'
export const GET_HRMS74E_INDEX_DISP = 'GET_HRMS74E_INDEX_DISP'
export const SET_HRMS74E_INDEX_ADD_INLINE = 'SET_HRMS74E_INDEX_ADD_INLINE'
export const RECEIVED_HRMS74E_INDEX_ADD_INLINE = 'RECEIVED_HRMS74E_INDEX_ADD_INLINE'
export const SET_HRMS74E_DETAIL_DISP = 'SET_HRMS74E_DETAIL_DISP'
export const GET_HRMS74E_DETAIL_DISP = 'GET_HRMS74E_DETAIL_DISP'
export const SET_HRMS74E_COLUMNS = 'SET_HRMS74E_COLUMNS'
export const GET_HRMS74E_COLUMNS = 'GET_HRMS74E_COLUMNS'
export const SET_HRMS74E_LABELS = 'SET_HRMS74E_LABELS'
export const GET_HRMS74E_LABELS = 'GET_HRMS74E_LABELS'
export const RECEIVED_HRMS74E_COLUMNS_LABELS = 'RECEIVED_HRMS74E_COLUMNS_LABELS'
export const SET_HRMS74E_INDEX = 'SET_HRMS74E_INDEX'
export const GET_HRMS74E_INDEX = 'GET_HRMS74E_INDEX'
export const SET_HRMS74E_INDEX_SEARCH_PARAMS = 'SET_HRMS74E_INDEX_SEARCH_PARAMS'
export const GET_HRMS74E_INDEX_SEARCH_PARAMS = 'GET_HRMS74E_INDEX_SEARCH_PARAMS'
export const RECEIVED_HRMS74E_INDEX = 'RECEIVED_HRMS74E_INDEX'
export const SET_HRMS74E_INDEX_SELECTED = 'SET_HRMS74E_INDEX_SELECTED'
export const GET_HRMS74E_INDEX_SELECTED = 'GET_HRMS74E_INDEX_SELECTED'
export const SET_HRMS74E_DETAIL = 'SET_HRMS74E_DETAIL'
export const GET_HRMS74E_DETAIL = 'GET_HRMS74E_DETAIL'
export const RECEIVED_HRMS74E_DETAIL = 'RECEIVED_HRMS74E_DETAIL'
export const TOGGLE_HRMS74E_PAGE = 'TOGGLE_HRMS74E_PAGE'
export const POST_HRMS74E_SEND_APPROVE = 'POST_HRMS74E_SEND_APPROVE'
export const POST_HRMS74E_INDEX_SAVE = 'POST_HRMS74E_INDEX_SAVE'

export const SET_HRMS74E_INDEX_INLINE_DATA = 'SET_HRMS74E_INDEX_INLINE_DATA'
export const GET_HRMS74E_INDEX_INLINE_DATA = 'GET_HRMS74E_INDEX_INLINE_DATA'

export const GET_HRMS74E_COURSEND = 'GET_HRMS74E_COURSEND'



// WEBPACK FOOTER //
// ./src/store/modules/hrms74e/mutation-types.js